import { render, staticRenderFns } from "./BasketContent.vue?vue&type=template&id=27108b55&scoped=true&"
import script from "./BasketContent.vue?vue&type=script&lang=js&"
export * from "./BasketContent.vue?vue&type=script&lang=js&"
import style0 from "./BasketContent.vue?vue&type=style&index=0&id=27108b55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27108b55",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/basket_content.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fbasket%2FBasketContent.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports